// @owners { team: patients }
import { type RouteName } from '@alto/navigation';

export const getProgynyWizardNextRoute = (
  currentRouteName: string | undefined,
  firstFill?: boolean | null,
): RouteName | undefined => {
  switch (currentRouteName) {
    case 'RouteProgynyWizardIntro':
      return 'RouteProgynyWizardIntro2';

    case 'RouteProgynyWizardIntro2':
      return 'RouteProgynyWizardIntro3';

    case 'RouteProgynyWizardIntro3':
      return firstFill ? 'RouteProgynyWizardStartDate' : 'RouteProgynyWizardTriggerDate';

    case 'RouteProgynyWizardStartDate':
    case 'RouteProgynyWizardTriggerDate':
      return 'RouteProgynyWizardDosageCheck';

    case 'RouteProgynyWizardDosageCheck':
      return 'RouteProgynyWizardLeftoverMeds';

    case 'RouteProgynyWizardLeftoverMeds':
      return 'RouteProgynyWizardCalculating';

    case 'RouteProgynyWizardCalculating':
      return 'RouteProgynyWizardQuantityReview';

    default:
      return undefined;
  }
};
